import React from 'react';
import { ShieldCheck, ShieldAlert, X, Loader2 } from 'lucide-react';
import './darkWebDetailsModal.css'; // Importing the custom CSS file below
import { Loading } from '../../../common';

const DarkWebDetailsModal = ({ identity, isOpen, onClose, darkWebDetails, loading }) => {
  // Guard clause: Don't render anything if the modal shouldn't be open
  if (!isOpen) return null;

  return (
    <div className="dws-modal-overlay">
      <div className="dws-modal-container">
        
        {/* Close Button */}
        <button onClick={onClose} className="dws-close-btn" aria-label="Close modal">
          <X size={20} />
        </button>

        {loading ? (
          /* --- LOADING STATE --- */
          <Loading text='Scanning Dark Web Data'/>
        ) : !darkWebDetails || !darkWebDetails.success ? (
          /* --- ERROR OR NO DATA FALLBACK STATE --- */
          <div className="dws-content-safe">
            <h3 className="dws-title-risk" style={{ fontSize: '18px' }}>Unable to retrieve data</h3>
            <p className="dws-description">
              Something went wrong while trying to fetch the dark web reports. Please try again later.
            </p>
          </div>
        ) : !darkWebDetails.data.found ? (
          /* --- SAFE STATE --- */
          <div className="dws-content-safe">
            <div className="dws-icon-wrapper dws-icon-safe">
              <ShieldCheck size={36} />
            </div>
            
            <h3 className="dws-title-safe">Congratulations!</h3>
            
            <p className="dws-description">
              Great news! Your identity details for <span className="dws-highlight">"{darkWebDetails?.data?.username}"</span> were not found in any known data leaks or dark web repositories.
            </p>

            <div className="dws-status-badge dws-status-safe">
              Status: <span>Monitored & Secure</span>
            </div>
          </div>
        ) : (
          /* --- RISK DETECTED STATE --- */
          <div className="dws-content-risk">
            {/* Warning Header */}
            <div className="dws-risk-header">
              <div className="dws-icon-wrapper dws-icon-risk">
                <ShieldAlert size={36} />
              </div>
              <h3 className="dws-title-risk">Security Alert!</h3>
              <p className="dws-risk-subtitle">High Risk Detected</p>
            </div>

            {/* Breach Details Body */}
            <div className="dws-risk-body">
              <p className="dws-description">
                Your credentials have been exposed on the dark web. Immediate action is recommended.
              </p>

              <div className="dws-details-box">
                <div className="dws-details-row">
                  <span className="dws-label">Compromised User:</span>
                  <span className="dws-value-highlight">{darkWebDetails?.data?.username}</span>
                </div>
                
                <div className="dws-details-column">
                  <span className="dws-label">Leaked Source:</span>
                  <code className="dws-source-code">{darkWebDetails?.data?.source}</code>
                </div>
              </div>
            </div>
          </div>
        )}
        
      </div>
    </div>
  );
};

export default DarkWebDetailsModal;